import React, { useState, useEffect } from 'react';
import './TemplateModal.css';

interface TemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, description: string, isGlobal?: boolean) => void;
  initialName?: string;
  loading?: boolean;
}

const TemplateModal: React.FC<TemplateModalProps> = ({
  isOpen,
  onClose,
  onSave,
  initialName = '',
  loading = false
}) => {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (isOpen) {
      setName(initialName);
      setDescription('');
    }
  }, [isOpen, initialName]);

  const handleSave = (isGlobal = false) => {
    if (name.trim()) {
      onSave(name.trim(), description.trim(), isGlobal);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    } else if (e.key === 'Enter' && e.metaKey) {
      handleSave();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="template-modal-overlay" onClick={onClose}>
      <div className="template-modal" onClick={e => e.stopPropagation()} onKeyDown={handleKeyDown}>
        <div className="template-modal-header">
          <h2>Create Template</h2>
          <button className="template-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="template-modal-content">
          <div className="template-field">
            <label htmlFor="template-name">Template Name</label>
            <input
              id="template-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter template name"
              autoFocus
              disabled={loading}
            />
          </div>
          
          <div className="template-field">
            <label htmlFor="template-description">Description (optional)</label>
            <textarea
              id="template-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Add a description for this template"
              rows={3}
              disabled={loading}
            />
          </div>
        </div>
        
        <div className="template-modal-actions">
          <button 
            className="template-btn template-btn-secondary" 
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          {/* <button 
            className="template-btn template-btn-global" 
            onClick={() => handleSave(true)}
            disabled={loading || !name.trim()}
            title="For testing purposes - adds template to global templates"
          >
            {loading ? 'Saving...' : '+ Global Template'}
          </button> */}
          <button 
            className="template-btn template-btn-primary" 
            onClick={() => handleSave(false)}
            disabled={loading || !name.trim()}
          >
            {loading ? 'Saving...' : 'Save Template'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateModal; 